<template>
  <div
    class="book-tool"
    :class="[this.isOpen ? 'book-tool--open' : 'book-tool--closed', this.crossingElement ? 'contrast' : '']"
    ref="bookToolTableMobile"
  >
    <div class="book-tool__btn portal" @click="toggle()" :class="this.themeSite">
      <span>
        <div class="book-tool__btn-inner">{{ translations.bookTable }}</div>
      </span>
    </div>

    <div v-if="this.isOpen" class="book-tool__popout-mobile" :class="this.themeSite">
      <!-- <LocationPickerRestaurant
        v-if="this.isOpen"
        :locations-data="locationsData"
        :translations="translations"
      />-->

      <!-- <div class="book-tool__popout-inner" ref="popoutContents"> -->
      <radio-list-restaurants-mobile
        v-if="this.isOpen"
        :translations="translations"
        :location-options="locationOptions"
        class="mr4"
      />

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import s from "../store"
import h from "../helpers"
import RadioListRestaurantsMobile from "./RadioListRestaurantsMobile.vue"

export default {
  name: "BookTableToolMobile",

  components: {
    RadioListRestaurantsMobile
  },

  data: function() {
    return {
      crossingElement: true,
      touched: false,
      isOpen: false,
      collapsedX: null,
      collapsedY: null,
      borderRadius: 46,
      collapsedBorderRadius: null
    }
  },

  props: {
    locationOptions: { type: Array },
    showLocation: {
      type: Boolean,
      default: false
    },
    themeSite: {
      type: String,
      default: "portal"
    },
    translations: { type: Object }
  },

  mounted: function() {
    if (s.debug)
      console.log(
        "BookTableToolMobile with locationOptions:",
        this.locationOptions
      )

    // init pagePositionDetector
    this.pagePositionDetector()
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside)
      }
    }
  },

  computed: {
    booktoolClasses: function() {
      if (this.touched && !this.isOpen) {
        return "book-tool--closed"
      } else if (this.isOpen) {
        return "book-tool--open"
      }
    },

    locationValue: function() {
      return s.state.bookingRestaurant.restaurant || "Location"
    },

    urlValue: function() {
      return s.state.bookingRestaurant.url || ""
    },

    isMobile: function() {
      return window.innerWidth < 960
    }
  },

  methods: {
    onScroll(event) {
      // Close book tool when the users scrolls
      window.removeEventListener("scroll", this.onScroll)
      this.close()
    },

    onResize(event) {
      // Implement on resize
      if (this.isMobile) {
        return
      }
    },

    closeIfClickedOutside(event) {
      if (!event.target.closest(".book-tool")) {
        document.removeEventListener("click", this.closeIfClickedOutside)
        this.close()
      }
    },

    open: function(event) {
      this.isOpen = true
    },

    close: function() {
      this.isOpen = false
    },

    toggle: function() {
      this.isOpen = !this.isOpen
    },

    isInElement(buttonEl, targetEls) {
      const fixed_position =
        buttonEl.getBoundingClientRect().top + window.scrollY
      const fixed_height = buttonEl.offsetHeight

      this.crossingElement = false
      for (let i = 0; i < targetEls.length; i++) {
        const el = targetEls[i]
        const toCross_position = el.offsetTop
        const toCross_height = el.offsetHeight

        if (fixed_position + fixed_height < toCross_position) {
        } else if (fixed_position > toCross_position + toCross_height) {
        } else {
          this.crossingElement = true
        }
      }
    },

    pagePositionDetector() {
      this.$nextTick(() => {
        let els = document.querySelectorAll("[data-detect-section]")
        const buttonEl = this.$refs.bookToolTableMobile
        const _self = this
        if (els.length > 0) {
          window.addEventListener(
            "scroll",
            function(event) {
              _self.isInElement(buttonEl, els)
            },
            false
          )
        }
      })
    }
  }
}
</script>

<style>
.hover-b--yellow {
  transition: border-color 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.hover-b--yellow:hover,
.hover-b--yellow:focus,
.hover-b--yellow:active {
  border-color: #e1a724;
}

.dropdown__toggle[aria-expanded="true"] .hover-b--yellow {
  border-color: #e1a724;
}
</style>
